import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';
import {
  HEADER_HEIGHT,
  MAX_PAGE_HEIGHT,
  MAX_PAGE_WIDTH,
  MENU_WIDTH,
} from '../../../styles/constants';

const pageContainerHeaderHeight = '60px';

export const useStyles = makeStyles<Theme>()((theme) => ({
  pageWrapper: {
    position: 'relative',
    height: MAX_PAGE_HEIGHT,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  pageContainerWrapper: {
    display: 'flex',
    maxWidth: MAX_PAGE_WIDTH,
    gap: theme.spacing(1),
    width: '100%',
  },
  pageContainer: {
    width: `calc(${MAX_PAGE_WIDTH} - ${MENU_WIDTH} - 8px)`,
    borderRadius: '4px',
  },
  pageContainerContent: {
    height: `calc(${MAX_PAGE_HEIGHT} - ${HEADER_HEIGHT} - ${pageContainerHeaderHeight})`,
    maxHeight: `calc(${MAX_PAGE_HEIGHT} - ${HEADER_HEIGHT} - ${pageContainerHeaderHeight})`,
    overflowY: 'auto',
    overflowX: 'hidden',
  },

  divider: {
    display: 'block',
  },
  pageContainerHeader: {
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: '60px',
    padding: '16px',
  },
  pageContainerTitle: {
    display: 'flex',
    alignItems: 'center',
    transition: 'color 0.15s linear',

    '& svg': {
      transition: 'color 0.15s linear',
      marginRight: '8px',
      color: theme.palette.text.primary,
    },
  },

  clickable: {
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.primary.main,
      '& svg': {
        color: theme.palette.primary.main,
      },
    },
  },

  title: {
    whiteSpace: 'nowrap',
  },
}));
